// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"a91b21a3","705":"c17857a8","972":"20ba7cd2"}[chunkId] + ".chunk.css";
};